var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDeleteBottomTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84207 1.05261H13.1578C13.7392 1.05261 14.2104 1.52393 14.2104 2.10522V3.15783H5.78935V2.10522C5.78946 1.52393 6.26078 1.05261 6.84207 1.05261ZM4.73685 3.15794V2.10533C4.73685 0.942527 5.67938 0 6.84207 0H13.1578C14.3205 0 15.263 0.942527 15.263 2.10522V3.15783H18.421C18.7116 3.15783 18.9473 3.39343 18.9473 3.68413C18.9473 3.97483 18.7116 4.21043 18.421 4.21043H1.57892C1.28822 4.21043 1.05261 3.97483 1.05261 3.68413C1.05261 3.39343 1.28822 3.15783 1.57892 3.15783H4.73685V3.15794Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8421 17.3682C6.5514 17.3682 6.3158 17.1325 6.3158 16.8419V8.9472C6.3158 8.65661 6.5514 8.4209 6.8421 8.4209C7.13281 8.4209 7.36841 8.65661 7.36841 8.9472V16.8419C7.36841 17.1325 7.13281 17.3682 6.8421 17.3682Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0001 17.3682C9.70947 17.3682 9.47375 17.1325 9.47375 16.8419V8.9472C9.47375 8.65661 9.70947 8.4209 10.0001 8.4209C10.2906 8.4209 10.5264 8.65661 10.5264 8.9472V16.8419C10.5264 17.1325 10.2906 17.3682 10.0001 17.3682Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1578 17.3682C12.8672 17.3682 12.6315 17.1325 12.6315 16.8419V8.9472C12.6315 8.65661 12.8672 8.4209 13.1578 8.4209C13.4484 8.4209 13.6841 8.65661 13.6841 8.9472V16.8419C13.6841 17.1325 13.4485 17.3682 13.1578 17.3682Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.15796 18.9469V6.31537C3.15796 6.02467 3.39356 5.78906 3.68426 5.78906C3.97496 5.78906 4.21057 6.02467 4.21057 6.31537V17.8943C4.21057 18.4757 4.68188 18.9469 5.26317 18.9469H14.7369C15.3183 18.9469 15.7895 18.4757 15.7895 17.8943V6.31537C15.7895 6.02467 16.0252 5.78906 16.3158 5.78906C16.6064 5.78906 16.8421 6.02467 16.8421 6.31537V18.9469C16.8421 19.5283 16.3709 19.9995 15.7895 19.9995H4.21057C3.62917 19.9996 3.15796 19.5283 3.15796 18.9469Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDeleteBottomTable);
export default __webpack_public_path__ + "static/media/icon-delete-bottom-table.fc2efa675b4d9bf5def7cf16ae1a1c51.svg";
export { ForwardRef as ReactComponent };